/**
 * Responsible for colouring the header and data indicators
 * @param colourList
 */
export default function colourCarouselNav(colourList) {

    const headers = $('.headerSection');

    // initialize a small object that will be responsible for keeping track of the lowest indexes
    // these indexes will then be use for the header sections
    const lowestRatings = {

        customer: null,
        assessor: null,

        reset() {
            // Beware of object references when refactoring
            this.customer = {
                index: 9999,
                rating: null,
            };

            this.assessor = {
                index: 9999,
                rating: null,
            };
        },

        updateAssessor(rating) {
            return this.shouldUpdateThenUpdate(rating, this.assessor);
        },

        updateCustomer(rating) {
            return this.shouldUpdateThenUpdate(rating, this.customer);
        },

        extractRatingInformation(rating) {
            const colour = getRatingColour(rating);
            return {
                colour,
                index: colourList.indexOf(colour),
            };
        },

        shouldUpdateThenUpdate(original, tracker) {
            if(original === null || original.length === 0) {
                return null;
            }

            const ratingInfo = this.extractRatingInformation(original);
            if(ratingInfo.index >= tracker.index) {
                return ratingInfo;
            }

            tracker.rating = original;
            tracker.index = ratingInfo.index;

            return ratingInfo;
        },

    };

    headers.each((index, header) => {
        header = $(header);
        lowestRatings.reset();
        const headerCircle = $(`.tabs a[href='#${header.attr('id')}'] .rating-circle`);

        // loop through all the header sections as we'll need to update their rating-colour
        // while here, we should set each indicator item's (the circles on the carousel) colour
        if (header.find('.indicator-item').length) {
            header.find('.indicator-item').each((index, indicator) => {

                let carouselItem = header.find(`.carousel-item:nth-child(${index + 1})`);

                indicator = $(indicator);
                // initialize the tooltips on the indicator items
                indicator.tooltip({
                    delay: 50,
                    tooltip: carouselItem.data('question-sequence'),
                    position: 'top'
                });

                const ratings = carouselItem.find(`.rating-circle.actual`);
                // first rating will be the assessors if the assessor is viewing the page
                // or it will be the customers if they're viewing the page
                const firstRating = ratings.first();
                const lastRating = ratings.last();

                let assessorRating = null;
                let customerRating = null;

                // only set the last rating to a value otherwise it'll be equal to the first rating if it's the customer
                if(ratings.length > 1) {
                    assessorRating = firstRating;
                    customerRating = lastRating;
                }
                else {
                    customerRating = firstRating;
                }

                colourRatingCircle(indicator, customerRating, assessorRating);

                if(ratings.hasClass('last')) {
                    indicator.addClass('last');
                }
            });
        } else {
            const ratings = header.find(`.carousel-item .rating-circle`);

            // first rating will be the assessors if the assessor is viewing the page
            // or it will be the customers if they're viewing the page
            const firstRating = ratings.first();
            const lastRating = ratings.last();

            let assessorRating = null;
            let customerRating = null;

            // only set the last rating to a value otherwise it'll be equal to the first rating if it's the customer
            if(ratings.length > 1) {
                assessorRating = firstRating;
                customerRating = lastRating;
            }
            else {
                customerRating = firstRating;
            }

            colourRatingCircle(headerCircle, customerRating, assessorRating);
        }

        colourRatingCircle(headerCircle, lowestRatings.customer.rating, lowestRatings.assessor.rating);
    });

    function getRatingColour(rating) {
        const classList = rating.prop('classList');
        const lastClass = classList.item(classList.length - 1);

        const isLastClassColour = !!~colourList.indexOf(lastClass);

        return isLastClassColour ? lastClass : null;
    }

    function colourRatingCircle(circle, customerRating, assessorRating) {
        const assessorRatingInfo = lowestRatings.updateAssessor(assessorRating);
        const customerRatingInfo = lowestRatings.updateCustomer(customerRating);

        if (!customerRatingInfo) {
            return;
        }

        // slightly different logic to handle whether we want to colour half of the circle or the entire circle
        if(!assessorRatingInfo) {
            return circle
                .removeClass(colourList.join(' '))
                .addClass(customerRatingInfo.colour)
        }
        else {
            return circle.empty()
                .append($('<div>').addClass(assessorRatingInfo.colour))
                .append($('<div>').addClass(customerRatingInfo.colour));
        }
    }
}
